module.exports = __webpack_public_path__ + "static/19gde-6f6544ed1d403201b6b70f9e03960be8.gif";